import axios from 'axios';

export const provinceApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/province`,
    headers: {
        'Content-Type': 'application/json'
    }
})